module.exports = __webpack_public_path__ + "static/media/PoweredBySinou.a2af1209.jpeg";